import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const DiskCapacityContainer = styled.div<React.CSSProperties>`
  position: fixed;
  width: ${1700 * Screen.widthRatio}px;
  top: ${270 * Screen.widthRatio}px;
  height: ${862 * Screen.widthRatio}px;
  left: ${100 * Screen.widthRatio}px;
`;

export default withAnimation(DiskCapacityContainer);
